
export const environment = {
  production: false,
  // API_URL : "https://sandbox-api.xcelapp.com",
  // BUSINESS_API_URL : "https://sandbox-api.xcelapp.com/business-api",
  API_URL : "https://api.xcelapp.com",
  BUSINESS_API_URL : "https://api.xcelapp.com/business-api",

  X_APP_ID: '64c053730656499e578826c0',
  X_ISSUER_ID: '64c051b60656499e578826bf',
  PUBLIC_KEY: 'eTz.live_faf2ab8387b08df3d51d85c5e43f11e9d46f4a49cd9943b0f2fcd174bb7830d1',
  X_API_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjcmVhdGVkIjoxNjU0NzYwNjE0MjUwLCJlbnYiOiJkZXZlbG9wbWVudCIsImlkIjoiNjJhMWE0YTY4MDRmN2EwMDEzNzVkZGMxIiwidmVyc2lvbiI6MCwiaWF0IjoxNjU0NzYwNjE0LCJleHAiOjE2NTQ3Njc2MTR9.xo5LLqxhakDwknrBPc-guLyeE97UBaLupjSXn4rNfM4',

};
